
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Calendar } from './components/Calendar';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <main>
      <Hero />
      <About />
      <Services />
      <Calendar />
      <Contact />
      <Footer />
    </main>
  );
}
